import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
/**
 * Read-only recurrence summary shown in the collapsed Date & time view
 * ("Does not repeat" by default, or a short description of the active rule).
 * The interactive recurrence dropdown lives in the expanded ("Show more") view.
 */
export var RecurrenceSummary = function (_a) {
    var rule = _a.rule;
    var t = useTranslation('meetingRooms').t;
    var text = t('eventDetails.recurrence.options.does_not_repeat');
    if (rule) {
        try {
            var described = rule.toText();
            text = described.charAt(0).toUpperCase() + described.slice(1);
        }
        catch (_b) {
            // Fall back to the default label if the rule can't be described.
        }
    }
    return (_jsx(Typography.Text, { type: "secondary", style: { fontSize: 12 }, children: text }));
};
